import React from 'react';

const EventInfoCard = ({ event }) => (
  <div className="bg-white/50 backdrop-blur-sm border border-[#E5E5E5] rounded-lg p-6 space-y-6">
    <div>
      <div className="flex items-center gap-3 mb-4">
        <span className="px-3 py-1 bg-primary/10 text-primary rounded-lg text-sm font-semibold">
          {event.category}
        </span>
        <span className="px-3 py-1 bg-[#F5F5F5] text-[#525252] rounded-lg text-sm">
          {event.modality}
        </span>
      </div>
      <h1 className="text-3xl sm:text-4xl font-heading font-bold text-[#0A0A0A] mb-4" data-testid="event-title">
        {event.title}
      </h1>
      <p className="text-lg text-[#525252]" data-testid="event-description-short">
        {event.description_short}
      </p>
    </div>

    <div className="border-t border-[#E5E5E5] pt-6">
      <h2 className="text-xl font-semibold text-[#0A0A0A] mb-4">Descripción</h2>
      <p className="text-[#525252] leading-relaxed whitespace-pre-wrap" data-testid="event-description-long">
        {event.description_long}
      </p>
    </div>

    {event.tags && event.tags.length > 0 && (
      <div className="flex flex-wrap gap-2">
        {event.tags.map((tag) => (
          <span key={tag} className="px-3 py-1 bg-[#F5F5F5] text-[#525252] rounded-full text-sm">
            #{tag}
          </span>
        ))}
      </div>
    )}
  </div>
);

export default EventInfoCard;
